<template lang="pug">
    transition(name="fade" v-if="activeIndex > -1 && urls.length")
        v-img(:src="urls[activeIndex]" :key="activeIndex"
            style="position: absolute; left: 0; top: 0; width: 100%; height: 100%;")
            template(#placeholder)
                v-layout(fill-height align-center justify-center ma-0)
                    v-progress-circular(indeterminate color='grey lighten-5')
</template>

<script>
export default {
  name: "BackgroundAnimated",
  props: {
    delay: {
      type: Number,
      default: 6
    },
    urls: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: 0,
      timerInterval: -1
    };
  },
  methods: {
    startPlay() {
      clearInterval(this.timerInterval);
      this.timerInterval = setInterval(() => {
        this.activeIndex++;
        if (this.activeIndex >= this.urls.length) {
          this.activeIndex = 0;
        }
      }, this.delay * 1000);
    }
  },
  watch: {
    delay() {
      this.startPlay();
    },
    urls() {
      this.startPlay();
    }
  },
  mounted() {
    this.startPlay();
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
  }
};
</script>

<style scoped>
.fade-enter-active {
  transition: all 0.8s ease;
}

.fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.fade-enter,
.fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
